(function(){
    'use strict';

    angular.module('dataHandlingIsNotInSegment', ['ngAnimate', 'journey.canvas.srv', 'ngModalDragabble'])
        .controller('isNotInSegmentCtrl', ['$scope', '$rootScope', '$timeout', 'canvasService', 'helpers', isNotInSegmentCtrl]);

    function isNotInSegmentCtrl($scope, $rootScope, $timeout, canvasService, helpers){
        $scope.displayNotInListOptions = false;
        $scope.displayError = false;
        $scope.descriptionEmpty = false;
        $scope.search = {};

        $rootScope.$on('displayConditionIsNotInSegmentModal', function(evt, conn, showTip) {
            var entry = document.getElementById(conn.id).getBoundingClientRect();

            $scope.top = entry.top;
            $scope.left = entry.left;
            $scope.entryTop = entry.top;
            $scope.segmentData = $rootScope.segmentData;
            $scope.showTip = showTip;
            $scope.modalPos = $scope.calculateModalPos($scope.top, $scope.left);
            $scope.displayNotInListOptions = true;
            $scope.connections = angular.copy(conn);
            $scope.displayError = false;
            $scope.descriptionEmpty = false;
            $scope.selectedKey = $scope.translate('canvas.condition.isInSegment.selectSegment');

            $timeout(function() {
                $scope.setScrollLogic($scope.connections.id);
            }, 300);

            $(window).resize(function() {
                var entry = document.getElementById($scope.connections.id).getBoundingClientRect();
                $scope.$apply(function()  {
                    $scope.top = entry.top;
                    $scope.left = entry.left;
                    $scope.calculateModalPos($scope.top, $scope.left);
                });
            });
        });

        $rootScope.$on('hideConditionIsNotInSegmentModal', function() {
            $scope.displayError = false;
            $scope.displayNotInListOptions = false;
        });

        $rootScope.$on('displayConditionIsNotInSegmentModalError', function() {
            $scope.displayError = true;
        });

        $scope.calculateModalPos = function(top, left) {
            var currentTopPercent = ((top/window.innerHeight) * 100);
            var currentLeftPercent = ((left/window.innerWidth) * 100);
            var fixedHeight = 400;
            var fixedwidth = 450;

            if($scope.modalWindow) {
                fixedwidth = 610;
                fixedHeight = 600;
            }

            if((left + 160) > window.innerWidth) {
                currentLeftPercent = 20;
                left = 0;
            }

            var topVal = currentTopPercent + _calculateTopByPos();

            $scope.modalTop = (topVal < 0)? '0%' : (topVal).toFixed(0) + '%';
            $scope.modalLeft = ( currentLeftPercent + _calculateLeftByPos()).toFixed(0) + '%';

            function _calculateTopByPos() {
                var totalTop = top + fixedHeight,
                    resTop = 0;

                if(totalTop > window.innerHeight) {
                    resTop = -38;
                    if($scope.modalWindow) {
                        resTop = -55;
                    }
                }

                return resTop;
            }

            function _calculateLeftByPos() {
                var totalLeft = left + fixedwidth,
                    resLeft = 14;

                if($scope.showTip) {
                    resLeft = 22;
                }

                if(totalLeft > window.innerWidth) {
                    resLeft = -20;
                    if($scope.modalWindow) {
                        resLeft = -25;
                    }
                }



                return resLeft;
            }
        };

        $scope.cancel = function() {
            $scope.displayNotInListOptions = false;

            var node = _.find($rootScope.connections, function (conn) {
                return conn.id === $scope.connections.id;
            });

            if (!node) {
                // Execute listener when user cancel the is not in segment node
                $rootScope.$broadcast('deleteIsNotInSegmentNode' + $scope.connections.id);
            }
        };

        $scope.save = function() {
            Intercom('trackEvent', 'AP - IsnotinSegment');
            $rootScope.$emit('saveConditionIsNotInSegmentData' + $scope.connections.id, $scope.connections, $scope.descriptionEmpty);
        };

        //Toggle List Item to check if a checkbox is checked, If not we add it to the array of IDs, if not we delete it and just save the ones selected
        $scope.toggelListItem = function (listItem) {
            if($scope.connections.isDummy) {
                $scope.connections.data.selectedList = [];
                delete $scope.connections.isDummy;
            }

            $scope.connections.data.selectedList = [];
            $scope.connections.data.selectedList.push(listItem);

            if ($scope.connections.data.selectedList.length) {
                $scope.selectedKey = $scope.translate('commons.editSelection');
            } else {
                $scope.selectedKey = $scope.translate('canvas.condition.isInSegment.selectSegment');
            }
        };

        $scope.displayModal = function(evt) {
            var windowHeight = window.innerHeight * 0.50;
            //Bottom to top
            if (evt.clientY > windowHeight) {
                $(".poc-list").css("top","-135px");
            }else {
                $(".poc-list").css("top","");
            }
            $scope.modalWindow = true;
            $scope.segmentData = $rootScope.segmentData;
        };

        $scope.hideModal = function(clearList) {
            if(clearList) {
                $scope.selectedKey = $scope.translate('canvas.condition.isInSegment.selectSegment');
                $scope.connections.data.selectedList = [];
            }
            $scope.modalWindow = false;
            $scope.search.list = "";
            $scope.segmentData = $rootScope.segmentData;
        };

        $scope.decodeHtml = (html) => {
            var txt = document.createElement("textarea");
            txt.innerHTML = html;
            return txt.value;
        };

        $scope.parseDescription = function(desc, selected) {
            if (desc && typeof desc === 'object'){
                var descriptionCheck = false;
                for (var item in desc){
                    if(desc[item]) {
                        $scope.descriptionEmpty = false;
                        descriptionCheck = true;
                        //Lists that are currently selected on the node
                        var totalLists = $scope.connections.data.selectedList.length;
                        desc = $scope.decodeHtml(helpers.getContactListItem(desc[item], $scope.ListName, $scope.segmentData));

                        //One list selected and > 19
                        if ( totalLists === 1 && desc.length > 19) {
                            desc = desc.slice(0, 19) + '...';
                        //More than one selected
                        } else if (totalLists > 1) {
                             desc = totalLists + " Segment Selected";
                        //One selected but < 19
                        }  else if (totalLists === 1 && desc.length < 19) {
                            desc = desc;
                        }
                        break;
                    }
                }
                if(!descriptionCheck) {
                    $scope.descriptionEmpty = true;

                    if (selected === 'showSelectedList') {
                        return '';
                    } else {
                        return $scope.translate('commons.enterDetails');
                    }
                }

            } else {
                $scope.descriptionEmpty = true;

                if (selected === 'showSelectedList') {
                    return '';
                } else {
                    return $scope.translate('commons.enterDetails');
                }
            }

            return desc;
        };

        $scope.setScrollLogic = function(id) {
            $scope.listLoader = false;
            angular.element(
                document.getElementById('contactSegmentContainer' + id)).bind("scroll",
                function () {
                    if(!$scope.listLoader && !$rootScope.stopLoadingList && !$scope.search.list) {
                        $scope.listLoader = true;
                        canvasService.getSegments($rootScope.segmentListOffset, 10)
                            .success(function(data) {
                                if(!data.Results.length) {
                                    $rootScope.stopLoadingList = true;
                                }
                                else {
                                    $rootScope.segmentListOffset++;
                                    $rootScope.segmentData = _.uniqBy($rootScope.segmentData.concat(data.Results), 'SegmentId');
                                    $scope.segmentData = $rootScope.segmentData;
                                }
                                $scope.listLoader = false;
                            })
                            .error(function() {
                                $scope.listLoader = false;
                            })
                    }
                }
            );
        };

        $scope.searching = false;
        $scope.search.search =  (val) => {
            if(val && val.length > 0 && !$scope.searching) {
                $scope.searching = true;
                canvasService.searchContactSegment(val)
                    .then((res) => {
                        $scope.searching = false;
                        $rootScope.segmentData = _.uniqBy($rootScope.segmentData.concat(res.data.Results), 'ListId');
                        $scope.segmentData = [];
                        if($scope.connections.data.selectedList && $scope.connections.data.selectedList.length) {
                            $scope.connections.data.selectedList.forEach((item) => {
                                for (let i = 0; i < $rootScope.segmentData.length; i++) {
                                    if ($rootScope.segmentData[i].ListId === item) {
                                        $scope.segmentData.push($rootScope.segmentData[i]);
                                        break;
                                    }
                                }
                            });
                        }

                        $scope.segmentData = $scope.segmentData.concat(res.data.Results);
                    })
                    .catch(() => {
                        $scope.searching = false;
                    });
            } else {
                $scope.segmentData = $rootScope.segmentData;
            }
        };
    };
})();



// WEBPACK FOOTER //
// ./app/controllers/modals/conditionIsNotInSegmentController.js